import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'services/toast.service';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReadingRoomListItem } from 'types/reading-room.interface';
import { ApiService } from 'services/api.service';
import { NgClass } from '@angular/common';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { getControlsWithErrors, MAX_LENGTH_NAME } from 'util/form.utility';
import { BackofficeReadingRoomSubmissionCard, ReassignReadingRoomSubmissionRequest } from 'types/service.interface';
import { SearchUserInputComponent } from 'components/search-user-input/search-user-input.component';

@Component({
  selector: 'app-reassign-user-modal',
  standalone: true,
  imports: [TranslateModule, NgClass, TooltipComponent, ReactiveFormsModule, SearchUserInputComponent],
  templateUrl: './reassign-user-modal.component.html',
  styleUrls: ['./reassign-user-modal.component.scss', '../../form/base-form.scss']
})
export class ReassignUserModalComponent extends BaseFormModalComponent implements OnInit, OnChanges, AfterViewInit {
  public readonly maxFieldLength = MAX_LENGTH_NAME;
  @Input() isOpen!: boolean;
  @Input() disabledUsersOptions: string[] = [];
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Output() update: EventEmitter<BackofficeReadingRoomSubmissionCard> = new EventEmitter<BackofficeReadingRoomSubmissionCard>();
  @ViewChild('content') content!: TemplateRef<any>;

  readingRooms: ReadingRoomListItem[] = [];
  shouldRenderTooltip = false;
  get reasonForUser(): AbstractControl<any, any> | null {
    return this.form.get('reasonForUser');
  }
  get userId(): AbstractControl<any, any> | null {
    return this.form.get('userId');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService,
    private apiService: ApiService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit(): void {
    if (this.application.responsibleUser?.id) {
      this.disabledUsersOptions.push(this.application.responsibleUser?.id);
    }
  }

  ngAfterViewInit(): void {
    if (this.isOpen) {
      this.fillForm();
      this.shouldRenderTooltip = false;
      this.open(this.content);
      setTimeout(() => {
        this.shouldRenderTooltip = true;
      }, 10);
    }
  }

  override ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.fillForm();
      this.shouldRenderTooltip = false;
      setTimeout(() => {
        this.shouldRenderTooltip = true;
      }, 10);
    }
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      userId: [null, [Validators.required]],
      reasonForUser: ['', [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]]
    });
  }

  protected override close(): void {
    super.close();
  }

  submit(): void {
    if (this.form.valid) {
      const args: ReassignReadingRoomSubmissionRequest = {
        readingRoomSubmissionId: this.application.id,
        ...this.form.value
      };

      this.apiService.reassignReadingRoomSumbission(args).subscribe((updatedApplication: BackofficeReadingRoomSubmissionCard) => {
        this.toastService.showSuccess('reassignSubmissionSuccess', '', {
          shouldTranslate: true
        });
        this.close();
        this.update.emit(updatedApplication);
      });
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.reassignUser');
    }
  }

  onUserSelected(userId: string) {
    this.form.get('userId')?.setValue(userId);
  }
}
